<div class="employment-state">
  @if (isNewMessages) {
    <app-badge [flavor]="'alert'" i18n="@@badge.newMessages">{{ unreadMessages }} Neue
        Nachrichten
    </app-badge>
  }
  @if (sharingRequested) {
    <app-badge [flavor]="isActionRequired ? 'alert' : ''" i18n="@@badge.requestPending">Anfrage
        ausstehend
    </app-badge>
  }
  @if (contactDataShared) {
    <app-badge [flavor]="'alert'" i18n="@@badge.contactDetailsShared">Kontaktdaten geteilt
    </app-badge>
  }
  @if (isInTeam && !isPA) {
    <app-badge [flavor]="'alert'" i18n="@@badge.onYourTeam">In Ihrem Team</app-badge>
  }
  @if (isInTeam && isPA) {
    <app-badge [flavor]="'alert'" i18n="@@badge.inYourTeamPARole">Sie sind Mitglied des Teams
    </app-badge>
  }
</div>
